"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get maskPhilsysNumber () {
        return maskPhilsysNumber;
    },
    get normalizePhMobile () {
        return normalizePhMobile;
    },
    get normalizePhilsysNumber () {
        return normalizePhilsysNumber;
    },
    get toCanonicalPhilhealthPin () {
        return toCanonicalPhilhealthPin;
    }
});
/**
 * Normalizers for the patient identifiers captured at registration. Each
 * returns the single canonical stored form, or `null` when the input can't
 * be one. They are pure so the web form and the API share the same rules.
 *
 * Every value handled here is PHI: never log inputs or outputs.
 */ const SEPARATORS = /[\s-]/g;
function toCanonicalPhilhealthPin(input) {
    const digits = input.replace(SEPARATORS, '');
    if (!/^\d{12}$/.test(digits)) {
        return null;
    }
    return `${digits.slice(0, 2)}-${digits.slice(2, 11)}-${digits.slice(11)}`;
}
function normalizePhilsysNumber(input) {
    const digits = input.replace(SEPARATORS, '');
    if (!/^\d{16}$/.test(digits)) {
        return null;
    }
    return digits;
}
function maskPhilsysNumber(stored) {
    if (!/^\d{16}$/.test(stored)) {
        return null;
    }
    return `••••-••••-••••-${stored.slice(12)}`;
}
function normalizePhMobile(input) {
    const compact = input.replace(/[\s\-.()]/g, '');
    const match = /^(?:\+?63|0)(9\d{9})$/.exec(compact);
    if (!match) {
        return null;
    }
    return `+63${match[1]}`;
}
